// Helpers minimos de SEO/Open Graph para la landing publica (no requiere
// libreria externa; setea/actualiza tags existentes o los crea si faltan).

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export function applyLandingSeo({ title, description, ogImage, url }) {
  if (title) document.title = title;
  setMeta("name", "description", description);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  setMeta("property", "og:type", "website");
  if (url) setMeta("property", "og:url", url);
  if (ogImage) setMeta("property", "og:image", ogImage);
  setMeta("name", "twitter:card", "summary_large_image");
}

export function applyStructuredData(data) {
  let el = document.getElementById("landing-structured-data");
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "landing-structured-data";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}
